import React, { useState, useEffect } from "react";
import { Box, useTheme, Typography, Grid, FormControl, Select, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import SubHeader from "../../../../../components/SubHeader";
import EmployeeList from "./EmployeeList";
import style from "./style";
import { formatDate } from "../../../../../utils/DateFormat";

const SalaryEmployeePage = ({ data, handleSearch, role, permission, page, total, setPage, open, setOpen, getEmployeeList,
  taxyearData, taxyearList, getPayslipTaxyearList, getTaxyear, subscriptionSummary, periodPayslipCount, fetchPeriodPayslipCount,
  isPayslipAccessDisabled }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isEmployeeRole = role === "Employee" || role === "employee";
  const [taxyear, setTaxyear] = useState(() =>
    taxyearData?.length
      ? { _id: taxyearData[0]._id, start: taxyearData[0].start, end: taxyearData[0].end }
      : { _id: "", start: "", end: "" }
  );
  const [customFrom, setCustomFrom] = useState(null);
  const [customTo, setCustomTo] = useState(null);

  useEffect(() => {
    if (taxyearData?.length && !taxyear._id) {
      const defaultTaxYear = taxyearData[0];
      setTaxyear({ _id: defaultTaxYear._id, start: defaultTaxYear.start, end: defaultTaxYear.end });
    }
  }, [taxyearData]);

  useEffect(() => {
    if (taxyear._id) {
      getTaxyear(taxyear._id);
      getPayslipTaxyearList(taxyear._id);
      if (isEmployeeRole && fetchPeriodPayslipCount) {
        fetchPeriodPayslipCount(taxyear.start, taxyear.end);
      }
    }
  }, [taxyear]);

  const handleViewCustomRange = () => {
    if (!customFrom || !customTo || isPayslipAccessDisabled) return;
    const startDate = dayjs(customFrom).format("YYYY-MM-DD");
    const endDate = dayjs(customTo).format("YYYY-MM-DD");
    if (fetchPeriodPayslipCount) fetchPeriodPayslipCount(startDate, endDate);
    navigate("/dashboard/salaryManagement", { state: { item: { startDate, endDate } } });
  };

  const handleTaxYearChange = (event) => {
    const selectedTaxYear = taxyearData.find((item) => item._id === event.target.value);
    if (selectedTaxYear) {
      const payload = {
        _id: selectedTaxYear._id,
        start: selectedTaxYear.start,
        end: selectedTaxYear.end,
      };

      setTaxyear(payload);
      getPayslipTaxyearList(selectedTaxYear._id)
      getTaxyear(selectedTaxYear._id);
    }
  };


  return (
    <>
      <Grid container sx={style.gridContainer}>
        <Grid>
          <Typography sx={style.leaveHeading}>{isEmployeeRole ? "My Payslips" : "Salary Management"}</Typography>
          {isEmployeeRole && isPayslipAccessDisabled && (
            <Typography sx={style.accessDisabledText}>
              Your payslip access has been disabled. Please contact your employer if you need a payslip.
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth sx={{
            "& .MuiOutlinedInput-root": {
              height: "2.8em",
              marginTop: "0.5em",
              borderRadius: "10px"
            }
          }} >
            <Typography shrink={true} sx={style.textsize}>Tax Year </Typography>
            <Select
              value={taxyear._id || ""}
              onChange={handleTaxYearChange}
              name="taxyear"
              sx={style.dropDownMenu}
              displayEmpty
            >
              <MenuItem disabled value="">
                Select
              </MenuItem>
              {taxyearData?.map((item) => (
                <MenuItem key={item._id} sx={style.dropDownMenu} value={item._id}>
                  {formatDate(item.start)} - {formatDate(item.end)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader
          title={isEmployeeRole ? "My Salary" : "Employee Salary"}
          infoTexts={
            isEmployeeRole
              ? [`Payslips Issued This Financial Year: ${periodPayslipCount ?? 0}`]
              : [
                subscriptionSummary
                  ? `Payslip Issued ${subscriptionSummary?.payslipsCreated ?? 0}/${subscriptionSummary?.payslipLimit ?? 0}`
                  : "Payslip Issued 0/0",
                subscriptionSummary
                  ? `Remaining ${subscriptionSummary?.payslipsRemaining ?? 0}`
                  : "Remaining 0",
              ]
          }
          isShow={true}
          isShowFilter={false}
          onchange={handleSearch}
          onCompanyChange={getEmployeeList}
          search={permission?.employee?.isEdit || role === "Admin"}
          dateRange={isEmployeeRole}
          fromDate={customFrom}
          setFromDate={setCustomFrom}
          toDate={customTo}
          setToDate={setCustomTo}
          btn={isEmployeeRole && !!customFrom && !!customTo && !isPayslipAccessDisabled}
          BtnText="View Payslips"
          onClick={handleViewCustomRange}
        />
        <EmployeeList data={data} taxyearList={taxyearList} setPage={setPage} page={page} total={total} permission={permission?.employee || role === "Admin"} open={open} setOpen={setOpen} isNavigationDisabled={isEmployeeRole && isPayslipAccessDisabled} />

      </Box>
    </>
  );
};

export default SalaryEmployeePage;
